import { computed, Ref } from '@nuxtjs/composition-api';
import { Cart } from '@vsf-enterprise/sap-commerce-webservices-sdk';
import { Logger, sharedRef, useVSFContext } from '@vue-storefront/core';
import { UseUserCartsComposable, UseUserCartsLoading, UseUserCartsError, LoadUserCartsProps } from '../types';
import * as actions from './actions';

export const useUserCarts = (): UseUserCartsComposable => {
  const context = useVSFContext();
  const carts: Ref<Cart[]> = sharedRef([], 'useUserCarts-carts');
  const loading: Ref<UseUserCartsLoading> = sharedRef({ load: false }, 'useUserCarts-loading');
  const error: Ref<UseUserCartsError> = sharedRef({ load: null }, 'useUserCarts-error');

  const methodController = async (
    methodName: string,
    callback: () => Promise<void>
  ) => {
    Logger.debug(`useUserCarts.${methodName}`);

    try {
      loading.value[methodName] = true;
      await callback();
      error.value[methodName] = null;
    } catch (err) {
      error.value[methodName] = err;
      Logger.error(`useUserCarts.${methodName}`, err);
    } finally {
      loading.value[methodName] = false;
    }
  };

  const load = async (props?: LoadUserCartsProps) => {
    await methodController('load', async () => {
      carts.value = await actions.loadUserCarts(context, props || {});
    });
  };

  return {
    carts: computed(() => carts.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value),
    load
  };
};
